import { Arrow as ArrowHover } from '@radix-ui/react-hover-card'
import { Arrow as ArrowPopover } from '@radix-ui/react-popover'
import { Arrow as ArrowTooltip } from '@radix-ui/react-tooltip'

import styles from './FloatingArrow.module.scss'

const ARROWS = {
  hover: ArrowHover,
  popover: ArrowPopover,
  tooltip: ArrowTooltip,
}

const HEIGHT = 8
const WIDTH = 16

type Props = {
  type: keyof typeof ARROWS
}

export const FloatingArrow = ({ type }: Props) => {
  const Arrow = ARROWS[type]

  return <Arrow className={styles.container} height={HEIGHT} width={WIDTH} />
}
